import React, {memo} from 'react';
//Material UI Components
import {
    Avatar,
    Box,
    Checkbox,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    makeStyles,
    Tooltip,
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
    cardText: {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        [theme.breakpoints.down("xs")]: {
            whiteSpace: "unset",
        }
    },
    container: {
        padding: '5px',
        [theme.breakpoints.down("sm")]: {
            padding: 0
        }
    },
    cardContainer: {
        cursor: "pointer",
        border: '1px solid rgba(0,0,0,0.25)',
        borderRadius: '5px',
        [theme.breakpoints.down("sm")]: {
            marginTop: '5px'
        }
    },
    padding_0: {
        padding: 0
    }
}));

const MemberCard = memo(({members, checkedMembers, setCheckedMembers}) => {
    const classes = useStyles();

    const handleToggle = (id) => () => {
        const currentIndex = checkedMembers.indexOf(id);

        if (currentIndex === -1) {
            checkedMembers.push(id);
            setCheckedMembers([...checkedMembers]);
        } else
            setCheckedMembers(checkedMembers.filter((_id) => _id !== id));
    };
    return (
        <Grid container className='space-3'>
            {members.map((member, i) =>
                <Grid item key={i} sm={4} xs={12}>
                    <Box className={classes.cardContainer}>
                        <Tooltip title={member.display_name} arrow>
                            <List className={classes.padding_0} onClick={handleToggle(member.id)}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={member?.color} alt={member.display_name} src='/'/>
                                    </ListItemAvatar>
                                    <ListItemText className={classes.cardText} primary={member.display_name}
                                                  secondary={member.member_type}/>
                                    <ListItemSecondaryAction>
                                        <Checkbox
                                            color="primary"
                                            edge="end"
                                            checked={checkedMembers.indexOf(member.id) !== -1}
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </List>
                        </Tooltip>
                    </Box>
                </Grid>)}
        </Grid>
    )
});

export default MemberCard;
